import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@Auth/useAuth";
import { productsClient } from "../clients/ProductsClient";
import { productKeys } from "./productKeys";

export function useProducts() {
  const { baseUser } = useAuth();
  const orgId = baseUser?.organization_id;
  return useQuery({
    queryKey: orgId ? productKeys.all(orgId) : ["products", "no-org"],
    queryFn: () => productsClient.list(orgId!),
    enabled: !!orgId,
  });
}

export function useProduct(id: string | undefined) {
  const { baseUser } = useAuth();
  const orgId = baseUser?.organization_id;
  return useQuery({
    queryKey:
      orgId && id ? productKeys.detail(orgId, id) : ["products", "no-detail"],
    queryFn: () => productsClient.get(id!),
    enabled: !!orgId && !!id,
  });
}
